import { getDefaultExportFromCjs as t } from "./_commonjsHelpers.mjs";
import { __require as r } from "../node_modules/lodash.throttle/index.mjs";
var o = r();
const s = /* @__PURE__ */ t(o);
export {
  s as default
};
